<div #wrapper class="week-options">
  <a
    *ngFor="let selected of weekdaySelected; index as index"
    [ngClass]="{'option-group': true, 'selected': selected}"
    (click)="onLabelClick($event)"
    [title]="getWeekdayByIndex(index)"
    [attr.data-id]="index"
  >
    <label>{{ getLocaleWeekdayByIndex(index).charAt(0) }}</label>
  </a>
</div>
